import { createFeature, createReducer, on } from '@ngrx/store';
import { I18nActions } from './i18n.actions';

interface I18nState {
  locale: string;
  error: string | null;
}

const initialState: I18nState = {
  locale: 'es',
  error: null,
};

export const i18nFeature = createFeature({
  name: 'i18n',
  reducer: createReducer(
    initialState,
    on(I18nActions.setLocaleSuccess, (state, { locale }) => ({
      ...state,
      locale,
      error: null,
    })),
    on(I18nActions.setLocaleFailure, (state, { error }) => ({
      ...state,
      error,
    })),
  ),
});
